
  import { EnumModel, JobTypeEnums } from '@/common/enumerations';
import { EventBus } from '@/event-bus';
import {
  Client,
  ClientSearchResultModel,
  IJobModel,
  JobModel,
  JobType as JobModelJobType,
  NetworkModel
} from '@/services/api.service';
import { JobUpdatedMessage } from '@/services/eventbus.models';
import * as StringUtils from '@/utilities/string.utils';
import debounce from 'lodash/debounce';
import { Component, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';

  @Component({
    components: {
      vSelect
    },
    props: {
      job: {
        type: Object as () => IJobModel,
        required: false
      },
      isInDialogMode: Boolean
    }
  })
  export default class JobEdit extends Vue {
    private selectedClient: ClientSearchResultModel | null = null;
    private matchingClients: ClientSearchResultModel[] = [];
    private gid: string = '';

    private availableNetworks: NetworkModel[] = [];
    private availableJobTypes: EnumModel[] = [];

    private localJob: IJobModel = new JobModel();

    protected mounted() {
      // get the networks
      this.gid = this.$props.job.gid;
      this.searchForClients(this.$props.job.client.name, () => false);

      this.localJob = new JobModel(this.$props.job);

      this.fetchInitialData();

      this.availableJobTypes.push(
        ...JobTypeEnums.sort((n1, n2) => {
          return StringUtils.stringCompare(n1.name || '', n2.name || '');
        })
      );
    }

    private async fetchInitialData() {
      // Load all the initial data required for this process
      const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);

      const [networks] = await Promise.all([clientService.getNetworks()]);

      this.availableNetworks = networks.sort((n1, n2) => {
        return StringUtils.stringCompare(n1.name || '', n2.name || '');
      });
    }

    private searchForClients(search: string, loading: (show: boolean) => any) {
      if (search !== undefined && search !== null && search !== '') {
        loading(true);
        this.internalSearchForClients(search, loading, this);
      }
    }

    // Taken from: https://stackoverflow.com/questions/40686767/using-lodash-debounce-in-angular2-typescript-scroll-not-working
    private internalSearchForClients = debounce((search, loading, vm) => {
      const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
      clientService.searchClients(search).then(data => {
        // push the results into the list
        vm.matchingClients = data;
        vm.selectedClient = data[0];
        loading(false);
      });
    }, 300);

    private updateJob() {
      console.log('updating Job');
      const me = this;
      const updateModel: IJobModel = {
        name: this.localJob.name,
        networkGid: this.localJob.networkGid!,
        clientGid: this.localJob.clientGid!,
        jobNumber: this.localJob.jobNumber,
        workOrderNumber: this.localJob.workOrderNumber,
        initiatorName: this.localJob.initiatorName,
        initiatorPhoneNumber: this.localJob.initiatorPhoneNumber,
        siteContactName: this.localJob.siteContactName,
        siteContactPhoneNumber: this.localJob.siteContactPhoneNumber,
        externalReferenceNumber: this.localJob.externalReferenceNumber,
        jobType: (this.localJob.jobType! as unknown) as JobModelJobType,
        isQuotedProject: this.localJob.isQuotedProject,
        projectDescription: this.localJob.projectDescription,
      };

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      // @ts-ignore
      this.$Progress.start();
      clientService.updateJob(this.gid, new JobModel(updateModel)).then(data => {
        // Route to the edit client screen?
        // @ts-ignore
        this.$Progress.finish();
        // @ts-ignore
        this.$awn.success('Job ' + me.$props.job.jobNumber + ' updated successfully');
        this.$emit('job-updated', data);
        EventBus.$emit('job-updated', new JobUpdatedMessage(data));
        this.closeModal();
      });
    }

    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      if (this.$props.isInDialogMode) {
        this.$modal.hide('modal-job-edit');
      }
    }
    // public closeModal()  {
    //   this.$root.$emit('bv::hide::modal', 'modal-job-edit', '#btnShow');
    // }
  }
